// ============================================================
// locales/cdpresse_home_translations.js
// Traductions FR / EN pour la home page CdPresse
// Usage : i18n.t('home.hero.title_1')
// ============================================================


export const cdpresseHomeTranslations = {
  fr: {
    home: {
      nav: {
        products:   'Produits',
        solutions:  'Solutions',
        pricing:    'Tarifs',
        resources:  'Ressources',
        login:      'Se connecter',
        cta:        'Commencer →',
        products_sub:   ['CdPresse Publisher', 'CdPresse Media', 'CdPresse BI (bientôt)'],
        solutions_sub:  ['Gouvernement', 'Partis politiques', 'Entreprises publiques', 'Entreprises privées & PME', 'Communautés', 'Territoires', 'Personnalités'],
        resources_sub:  ['Blog', 'API Docs', 'À propos'],
      },
      videobg: {
        baseline: 'Communiqués de presse narratifs augmentés par l’IA.'
      },
      hero: {
        eyebrow:    'RDC · KINSHASA · DEBYOO DRC · ISPT-KIN',
        title_1:    'L\'INFRASTRUCTURE',
        title_2:    'DE COMMUNICATION',
        title_3:    'OFFICIELLE DE LA RDC',
        for:        'POUR',
        words:      ['PUBLIER', 'DIFFUSER', 'MESURER', 'IMPACTER'],
        tagline:    'CdPresse est une plateforme IA qui transforme la communication officielle en RDC, aidant les organisations à publier avec professionnalisme, les médias à relayer avec précision, et les jeunes à bâtir les nouveaux métiers de l\'information.',
        cta_primary:   'Commencer gratuitement →',
        cta_secondary: 'Demander une démo',
        meta_version:  'CDP v1.0',
        meta_city:     'KINSHASA, RDC',
        meta_status:   'OPÉRATIONNEL',
        panel_title:   'CDP://SYSTEM',
        panel_live:    'LIVE',
        panel_rows: [
          ['PUBLISHER',  'ACTIF',    '#27ae60'],
          ['MEDIA',      'ACTIF',    '#27ae60'],
          ['BI',         'BIENTÔT',  '#f39c12'],
          ['API',        'STABLE',   '#27ae60'],
          ['AI ENGINE',  'EN LIGNE', '#27ae60'],
          ['ALGOLIA',    'INDEXÉ',   '#27ae60'],
        ],
        panel_meta: [
          '> SECTEURS: 14',
          '> LANGUES: FR/EN/SW/LN/KG/AR/ES/PT',
          '> TRAÇABILITÉ: 100%',
          '> SOURCE DE VÉRITÉ: ACTIVÉ_',
        ],
      },
      ticker: ['COMMUNICATION OFFICIELLE', 'SOURCE DE VÉRITÉ', 'IA CONGO-FRIENDLY', 'PARTAGE DE REVENUS', 'SOUVERAINETÉ NUMÉRIQUE', 'TRADUCTION MULTILINGUE', 'RELAYEURS', 'AMPLIFICATEURS', 'CONVERSATIONNALISTES', 'STORYTELLERS', 'FACT CHECKERS', 'NOUVEAUX MÉTIERS'],
      products: {
        label:    'NOS PRODUITS',
        title_1:  'Une plateforme.',
        title_2:  'Trois produits.',
        subtitle: 'De la publication à l\'intelligence, CdPresse couvre tout le cycle de l\'information officielle.',
        explore:  'Explorer',
        soon:     'Disponible prochainement',
        items: [
          {
            id: 'publisher', code: 'CDP-01', name: 'CdPresse Publisher', tag: 'Publier',
            tagline: 'Rédigez et diffusez vos communiqués de presse grâce à l\'IA, en quelques minutes, aux normes internationales.',
            features: ['Rédaction assistée par IA', 'Classification sectorielle automatique', 'Traduction multilingue', 'Analytics & métriques réelles'],
            status: 'DISPONIBLE', href: '/publisher',
          },
          {
            id: 'media', code: 'CDP-02', name: 'CdPresse Media', tag: 'Diffuser',
            tagline: 'Le feed professionnel pour journalistes, relayeurs, amplificateurs, conversationnalistes, storytellers: classifié, personnalisé, rémunéré.',
            features: ['Feed personnalisé par secteur', 'Liens de relay tracqués', 'Amplification avec page dédiée', 'Partage de revenus'],
            status: 'DISPONIBLE', href: '/media',
          },
          {
            id: 'bi', code: 'CDP-03', name: 'CdPresse BI', tag: 'Décider',
            tagline: 'Business intelligence et aide à la décision par l\'information, pour les organisations qui veulent voir loin.',
            features: ['Veille sectorielle en temps réel', 'Analyse de réputation', 'Gestion des risques informationnels', 'Rapports pour investisseurs'],
            status: 'BIENTÔT', href: null,
          },
        ],
      },
      stats: [
        { value: '14',   label: 'Secteurs économiques classifiés' },
        { value: '5+',    label: 'Langues supportées' },
        { value: '100%', label: 'Traçabilité des communications' },
        { value: '10K+',  label: 'Emplois à créer' },
      ],
      solutions: {
        label:    'SOLUTIONS',
        title_1:  'Conçu pour chaque',
        title_2:  'acteur de la RDC.',
        subtitle: 'CdPresse s\'adapte au contexte de chaque organisation, des institutions aux PME, des médias aux personnalités.',
        items: [
          'Gouvernement & Institutions',
          'Entreprises publiques',
          'Partis politiques',
          'Entreprises & PME',
          'Médias & Journalistes',
          'Communautés & Territoires',
          'ONG & Associations',
          'Personnalités publiques',
        ],
      },
      ecosystem: {
        label:    'L\'ÉCOSYSTÈME',
        title_1:  'Votre communiqué.',
        title_2:  'Un écosystème entier.',
        body:     'Quand vous publiez sur CdPresse, vous ne diffusez pas dans le vide. Relayeurs, amplificateurs, conversationnalistes, storytellers, fact-checkers, journalistes et médias reçoivent votre communiqué, classifié, ciblé, mesuré. Chaque maillon est rémunéré grâce à modèle de partage de revenus.',
        chain: [
          ['Publisher',    'Rédigez et publiez avec l\'IA'],
          ['Media',        'Relayé et amplifié par les médias'],
          ['Jeunes',       'Formés et rémunérés'],
          ['BI',           'Analysé pour la prise de décision'],
        ],
        nodes: ['Publisher', 'Media', 'Relayeurs', 'Jeunes', 'Institutions'],
      },
      paan: {
        title_1:  'Le premier PaaN en RDC.',
        title_2:  'Press-as-a-Network.',
        body:     `CdPresse est un réseau de syndication distribuée où le communiqué de presse n'est plus un simple PDF, mais devient un véritable actif de diffusion circulant dans un écosystème structuré. Ce modèle repose sur quatre rôles complémentaires: l'Émetteur (entreprise, institution ou organisation politique), le Relayeur (acteur individuel de diffusion), le Syndicateur (média ou gros diffuseur qui amplifie la portée), et le Curateur narratif (qui construit le contexte éditorial autour du message). Dans ce système, chacun participe à la circulation de l'information et peut devenir un distributeur indépendant de contenus, en monétisant l'attention qualifiée qu'il génère.`,
        become: 'Devenez un',
        categories: [
          {key: 'relayeur', label: 'RELAYEUR'}
        ],
      },
      cta: {
        label:    'COMMENCER',
        title_1:  'La RDC a toujours eu',
        title_2:  'une voix puissante.',
        body:     'Il lui manquait l\'infrastructure pour se faire entendre. CdPresse est cette infrastructure, disponible aujourd\'hui.',
        primary:  'Commencer gratuitement →',
        secondary:'Demander une démo',
      },
      footer: {
        tagline: 'L\'infrastructure de communication officielle de la RDC, propulsée par l\'IA.',
        partner: 'DEBYOO DRC · ISPT-KIN',
        copyright: '© 2026 CdPresse est un produit de Debyoo. Tous droits réservés.',
        cols: [
          { title: 'Produits',   links: ['CdPresse Publisher', 'CdPresse Media', 'CdPresse BI (bientôt)', 'Écosystème'] },
          { title: 'Solutions',  links: ['Gouvernement', 'Entreprises', 'Médias', 'PME & Communautés', 'Personnalités'] },
          { title: 'Ressources', links: ['Blog', 'API Docs', 'Centre d\'aide', 'À propos', 'Partenaires'] },
          { title: 'Légal',      links: ['Conditions', 'Confidentialité', 'Mentions légales', 'contact@cdpresse.cd'] },
        ],
      },
    },
  },

  en: {
    home: {
      nav: {
        products:   'Products',
        solutions:  'Solutions',
        pricing:    'Pricing',
        resources:  'Resources',
        login:      'Sign in',
        cta:        'Get started →',
        products_sub:   ['Publisher', 'Media', 'BI (coming soon)'],
        solutions_sub:  ['Government', 'Enterprises', 'Media', 'SMEs & Communities'],
        resources_sub:  ['Blog', 'API Docs', 'About'],
      },
      videobg: {
        baseline: 'AI-Powered Narrative Press Releases.'
      },
      hero: {
        eyebrow:    'DRC · KINSHASA · DEBYOO DRC · ISPT-KIN',
        title_1:    'THE OFFICIAL',
        title_2:    'COMMUNICATION',
        title_3:    'INFRASTRUCTURE OF THE DRC',
        for:        'TO',
        words:      ['PUBLISH', 'BROADCAST', 'MEASURE', 'IMPACT'],
        tagline:    'CdPresse is an AI-powered platform transforming official communication in the DRC, helping organizations publish with professionalism, media outlets relay with precision, and youth build the new careers of the information age.',
        cta_primary:   'Get started for free →',
        cta_secondary: 'Request a demo',
        meta_version:  'CDP v1.0',
        meta_city:     'KINSHASA, DRC',
        meta_status:   'OPERATIONAL',
        panel_title:   'CDP://SYSTEM',
        panel_live:    'LIVE',
        panel_rows: [
          ['PUBLISHER',  'ACTIVE',   '#27ae60'],
          ['MEDIA',      'ACTIVE',   '#27ae60'],
          ['BI',         'SOON',     '#f39c12'],
          ['API',        'STABLE',   '#27ae60'],
          ['AI ENGINE',  'ONLINE',   '#27ae60'],
          ['ALGOLIA',    'INDEXED',  '#27ae60'],
        ],
        panel_meta: [
          '> SECTORS: 14',
          '> LANGUAGES: FR/EN/SW/LN/KG/AR/ES/PT',
          '> TRACEABILITY: 100%',
          '> SOURCE OF TRUTH: ACTIVE_',
        ],
      },
      ticker: ['OFFICIAL COMMUNICATION', 'SOURCE OF TRUTH', 'CONGO-FRIENDLY AI', 'REVENUE SHARING', 'DIGITAL SOVEREIGNTY', 'MULTILINGUAL TRANSLATION', 'RELAYERS', 'AMPLIFIERS', 'CONVERSATIONALISTS', 'STORYTELLERS', 'FACT-CHECKERS', 'NEW CAREERS'],
      products: {
        label:    'OUR PRODUCTS',
        title_1:  'One platform.',
        title_2:  'Three products.',
        subtitle: 'From publication to intelligence, CdPresse covers the full cycle of official information.',
        explore:  'Explore',
        soon:     'Coming soon',
        items: [
          {
            id: 'publisher', code: 'CDP-01', name: 'CdPresse Publisher', tag: 'Publish',
            tagline: 'Draft and distribute your press releases with AI, in minutes, to international standards.',
            features: ['AI-assisted drafting', 'Automatic sector classification', 'Multilingual translation', 'Real analytics & metrics'],
            status: 'AVAILABLE', href: '/publisher',
          },
          {
            id: 'media', code: 'CDP-02', name: 'CdPresse Media', tag: 'Broadcast',
            tagline: 'The professional feed for journalists, relayers, amplifiers, conversationalists, storytellers and fact-checkers: classified, personalized, rewarded.',
            features: ['Personalized feed by sector', 'Tracked relay links', 'Amplification with dedicated page', 'Revenue sharing'],
            status: 'AVAILABLE', href: '/media',
          },
          {
            id: 'bi', code: 'CDP-03', name: 'CdPresse BI', tag: 'Decide',
            tagline: 'Business intelligence and decision-making through information, for organizations that want to see ahead.',
            features: ['Real-time sector monitoring', 'Reputation analysis', 'Informational risk management', 'Investor reports'],
            status: 'COMING SOON', href: null,
          },
        ],
      },
      stats: [
        { value: '14',   label: 'Economic sectors classified' },
        { value: '5+',    label: 'Supported languages' },
        { value: '100%', label: 'Communication traceability' },
        { value: '10K+',  label: 'Jobs to be created' },
      ],
      solutions: {
        label:    'SOLUTIONS',
        title_1:  'Built for every',
        title_2:  'player in the DRC.',
        subtitle: 'CdPresse adapts to the context of each organization, from institutions to SMEs, from media to public figures.',
        items: [
          'Government & Institutions',
          'State-owned enterprises',
          'Political parties',
          'Businesses & SMEs',
          'Media & Journalists',
          'Communities & Territories',
          'NGOs & Associations',
          'Public figures',
        ],
      },
      ecosystem: {
        label:    'THE ECOSYSTEM',
        title_1:  'Your press release.',
        title_2:  'An entire ecosystem.',
        body:     'When you publish on CdPresse, you\'re not broadcasting into a void. Relayers, amplifiers, conversationalists, storytellers, fact-checkers, journalists and media outlets receive your press release, classified, targeted, measured. Every link in the chain is rewarded thanks to a revenue-sharing model.',
        chain: [
          ['Publisher',    'Draft and publish with AI'],
          ['Media',        'Relayed and amplified by media'],
          ['Youth',        'Trained and paid'],
          ['BI',           'Analyzed for decision-making'],
        ],
        nodes: ['Publisher', 'Media', 'Relayers', 'Youth', 'Institutions'],
      },
      paan: {
        label:    'THE ECOSYSTEM',
        title_1:  'The First PaaN in the DRC.',
        title_2:  'Press-as-a-Network.',
        body:     `CdPresse is a distributed syndication network where a press release is no longer just a simple PDF, but becomes a true distribution asset circulating within a structured ecosystem. This model is built around four complementary roles: the Issuer (a company, institution or political organization), the Relay Partner (an individual distribution actor), the Syndicator (a media outlet or major distributor that amplifies reach), and the Narrative Curator (who creates editorial context around the message). Within this system, each participant contributes to the circulation of information and can become an independent content distributor, monetizing the qualified attention they generate.`,
        become: 'Become a',
        categories: [
          {key: 'relayeur', label: 'RELAY PARTNER'}
        ],
      },
      cta: {
        label:    'GET STARTED',
        title_1:  'The DRC has always had',
        title_2:  'a powerful voice.',
        body:     'It just lacked the infrastructure to be heard. CdPresse is that infrastructure, available today.',
        primary:  'Get started for free →',
        secondary:'Request a demo',
      },
      footer: {
        tagline: 'The official communication infrastructure of the DRC, powered by AI.',
        partner: 'DEBYOO DRC · ISPT-KIN',
        copyright: '© 2026 CdPresse is product of Debyoo. All rights reserved.',
        cols: [
          { title: 'Products',   links: ['Publisher', 'Media', 'BI (coming soon)', 'Ecosystem'] },
          { title: 'Solutions',  links: ['Government', 'Enterprises', 'Media', 'SMEs & Communities', 'Public figures'] },
          { title: 'Resources',  links: ['Blog', 'API Docs', 'Help center', 'About', 'Partners'] },
          { title: 'Legal',      links: ['Terms', 'Privacy', 'Legal notices', 'contact@cdpresse.cd'] },
        ],
      },
    },
  },
}
